import { browserPdfOutput, type PortCallsSource } from '@felix/ui';
import { officeApi } from './api.js';

/**
 * Ofiste liman aramaları (M13f; ADR 0052 §3): gemi yazar, ofis yetkili gemilerin aramalarını ve
 * belgelerini salt okunur görür. Belge gemiden geldiyse ofis adresinden açılır.
 */
export const officePortCallsSource: PortCallsSource = {
  scope: 'web',
  vessels: () => officeApi.vessels(),
  list: () => officeApi.portCalls(),
  get: (id) => officeApi.portCall(id),
  documents: (id) => officeApi.pmsAttachments(id, 'port_call'),
  documentUrl: (id) => `/api/office/attachments/${encodeURIComponent(id)}`,
  // Çıktı (ADR 0062 §3)
  brand: async () => {
    try {
      const { branding } = await officeApi.branding();
      return branding?.name ? { name: branding.name, logo: branding.logo ?? null } : null;
    } catch {
      return null;
    }
  },
  pdf: browserPdfOutput(),
};
